import { TripFolderMissionStaffs } from '../../lib/types/models/trip-folder/trip-folder'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripFolderMissionStaffs(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripFolder.getMissionToStaffs.url, { id }))
    .get<TripFolderMissionStaffs>()
}
